import { Text } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const TextFieldStaticConfig = {
  Icon: Text,
  type: DatabaseFieldTypeEnum.Text,
  labelKey: 'Database:DataTypes.Text',
};
